var includeHtmlLoader = function includeHtmlLoader(selector) {
  var hasComponentContent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var loader = '<div class="spinner"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>';
  var loaderContainer = document.createElement("div");
  loaderContainer.classList.add("loader-animated");
  loaderContainer.innerHTML = loader;
  var formattedSelector = hasComponentContent ? "".concat(selector, " .component-content") : selector;
  document.querySelector(formattedSelector).appendChild(loaderContainer);
};
export default includeHtmlLoader;